// extracted by mini-css-extract-plugin
module.exports = {"f-OrganismHeader":"Header_f-OrganismHeader__UBFAt","f-OrganismHeader-logo":"Header_f-OrganismHeader-logo__NNXK_"};